import React, { Component } from "react";
import { Card } from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGripVertical,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

export default class WidgetWrapper extends Component {
  renderCustomizeBar() {
    const { isCustomizing, title, onHide, dragHandleProps } = this.props;
    if (!isCustomizing) return null;

    return (
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          padding: "6px 10px",
          marginBottom: "6px",
          backgroundColor: "#e8f0fe",
          borderRadius: "4px",
        }}
      >
        <span
          {...dragHandleProps}
          style={{ cursor: "grab", padding: "4px", color: "#026fc2" }}
        >
          <FontAwesomeIcon icon={faGripVertical} />
        </span>
        <span
          style={{
            flex: 1,
            fontSize: "13px",
            fontWeight: 600,
            color: "#333",
          }}
        >
          {title}
        </span>
        <span
          style={{ cursor: "pointer", padding: "4px", color: "#db2828" }}
          onClick={onHide}
          title="Masquer ce widget"
        >
          <FontAwesomeIcon icon={faEyeSlash} />
        </span>
      </div>
    );
  }

  render() {
    const { title, noCard, children, isCustomizing } = this.props;

    const customizingStyle = isCustomizing
      ? {
          border: "2px dashed #c8d6e5",
          borderRadius: "8px",
          padding: "8px",
          backgroundColor: "#fafbfc",
        }
      : {};

    // If the child component already has its own Card, just wrap with customization bar
    if (noCard) {
      return (
        <div style={customizingStyle}>
          {this.renderCustomizeBar()}
          {children}
        </div>
      );
    }

    return (
      <div style={customizingStyle}>
        <Card
          title={title}
          className="mb-10 mb-30-xl"
          action={this.renderCustomizeBar()}
        >
          {children}
        </Card>
      </div>
    );
  }
}
